import { useClassified } from "@/contexts/classified";
import { useEffect, useState } from "react";
export const useTags = () => {
    var _a, _b;
    const [isSeen, setIsSeen] = useState(false);
    const [isContacted, setIsContacted] = useState(false);
    const tags = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tags;
    const classifiedId = (_b = useClassified()) === null || _b === void 0 ? void 0 : _b.id;
    useEffect(() => {
        var _a, _b, _c;
        setIsContacted((_a = localStorage.getItem("aviv_cdp_contact")) === null || _a === void 0 ? void 0 : _a.includes(classifiedId));
        setIsSeen(!((_b = localStorage.getItem("aviv_cdp_contact")) === null || _b === void 0 ? void 0 : _b.includes(classifiedId)) &&
            ((_c = localStorage.getItem("aviv_cdp_seen")) === null || _c === void 0 ? void 0 : _c.includes(classifiedId)));
    }, [classifiedId, isContacted]);
    return {
        isExclusive: !!(tags === null || tags === void 0 ? void 0 : tags.isExclusive),
        hasBrokerageFee: tags === null || tags === void 0 ? void 0 : tags.hasBrokerageFee,
        isNew: !!(tags === null || tags === void 0 ? void 0 : tags.isNew) && !isSeen && !isContacted,
        isSeen,
        isContacted,
    };
};
